import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO/SEO';

const Contacts = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [status, setStatus] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/api/v1/contacts/send`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                }
            );

            if (response.ok) {
                setStatus('success');

                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    message: ''
                });
            } else {
                const errorData = await response.json();

                alert(
                    errorData.detail ||
                        'Nepavyko išsiųsti žinutės.'
                );

                setStatus(null);
            }
        } catch (error) {
            console.error(
                'Error sending contact form:',
                error
            );

            alert(
                'Įvyko klaida siunčiant žinutę. Patikrinkite interneto ryšį.'
            );

            setStatus(null);
        }
    };

    return (
        <>
            <SEO
                title="Kontaktai – SmartPanda"
                description="Susisiekite su SmartPanda komanda. Turite klausimų apie mokomuosius žaidimus vaikams, prenumeratą ar platformos funkcijas? Parašykite mums."
                canonical="/kontaktai"
            />

            <div className="min-h-screen bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">

                    {/* Back button */}
                    <Link
                        to="/"
                        className="inline-flex items-center text-white hover:text-opacity-80 transition mb-8 font-bold"
                    >
                        ← Grįžti į pradžią
                    </Link>

                    <div className="bg-white bg-opacity-10 backdrop-blur-xl rounded-3xl shadow-2xl overflow-hidden border border-white border-opacity-20">
                        <div className="grid grid-cols-1 md:grid-cols-2">

                            {/* Contact Info */}
                            <div className="p-12 text-white">
                                <h1 className="text-4xl font-bold mb-6">
                                    Susisiekite su mumis
                                </h1>

                                <p className="text-xl text-opacity-90 mb-12">
                                    Turite klausimų apie platformą?
                                    Norite pasiūlyti naują funkciją?
                                    O gal tiesiog norite pasisveikinti?
                                    Mes visada pasiruošę padėti!
                                </p>

                                <div className="space-y-8">

                                    <div className="flex items-start gap-4">
                                        <div className="text-3xl">
                                            📧
                                        </div>

                                        <div>
                                            <h2 className="font-bold text-lg">
                                                El. paštas
                                            </h2>

                                            <p className="text-white text-opacity-70">
                                                info@korepetitorius.eu
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-4">
                                        <div className="text-3xl">
                                            📍
                                        </div>

                                        <div>
                                            <h2 className="font-bold text-lg">
                                                Adresas
                                            </h2>

                                            <p className="text-white text-opacity-70">
                                                Partizanų g. 61-806,
                                                LT-46270 Kaunas,
                                                Lietuva
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-start gap-4">
                                        <div className="text-3xl">
                                            📱
                                        </div>

                                        <div>
                                            <h2 className="font-bold text-lg">
                                                Telefonas
                                            </h2>

                                            <p className="text-white text-opacity-70">
                                                +370 605 52248
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-12">
                                    <h2 className="font-bold mb-4">
                                        Sekite mus
                                    </h2>

                                    <div className="flex gap-4">

                                        <a
                                            href="https://www.facebook.com/smartpanda.cloud/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="SmartPanda Facebook"
                                            className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-30 transition"
                                        >
                                            f
                                        </a>

                                        <a
                                            href="https://www.instagram.com/smartpanda.cloud/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="SmartPanda Instagram"
                                            className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-30 transition"
                                        >
                                            ig
                                        </a>

                                        <a
                                            href="https://www.tiktok.com/@smartpanda.education"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label="SmartPanda TikTok"
                                            className="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center cursor-pointer hover:bg-opacity-30 transition"
                                        >
                                            tt
                                        </a>
                                    </div>
                                </div>
                            </div>

                            {/* Contact Form */}
                            <div className="bg-white p-12">

                                {status === 'success' ? (
                                    <div className="h-full flex flex-col items-center justify-center text-center animate-fade-in">

                                        <div className="text-8xl mb-6">
                                            📩✨
                                        </div>

                                        <h2 className="text-3xl font-bold text-green-600 mb-4">
                                            Žinutė gauta!
                                        </h2>

                                        <p className="text-gray-600 text-lg mb-8">
                                            Ačiū, kad susisiekėte.
                                            Atsakysime jums per 24 valandas.
                                        </p>

                                        <button
                                            onClick={() =>
                                                setStatus(null)
                                            }
                                            className="px-8 py-3 bg-purple-600 text-white rounded-xl font-bold hover:bg-purple-700 transition"
                                        >
                                            Siųsti kitą žinutę
                                        </button>
                                    </div>
                                ) : (
                                    <form
                                        onSubmit={handleSubmit}
                                        className="space-y-6"
                                    >

                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">
                                                Jūsų vardas
                                            </label>

                                            <input
                                                type="text"
                                                required
                                                value={formData.name}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        name: e.target.value
                                                    })
                                                }
                                                className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-purple-500 outline-none transition"
                                                placeholder="Vardas Pavardė"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">
                                                El. pašto adresas
                                            </label>

                                            <input
                                                type="email"
                                                required
                                                value={formData.email}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        email: e.target.value
                                                    })
                                                }
                                                className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-purple-500 outline-none transition"
                                                placeholder="pavyzdys@elpastas.lt"
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">
                                                Tema
                                            </label>

                                            <select
                                                value={formData.subject}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        subject: e.target.value
                                                    })
                                                }
                                                className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-purple-500 outline-none transition"
                                            >
                                                <option value="">
                                                    Pasirinkite temą
                                                </option>

                                                <option value="pagalba">
                                                    Techninė pagalba
                                                </option>

                                                <option value="klausimas">
                                                    Bendras klausimas
                                                </option>

                                                <option value="pasiulymas">
                                                    Pasiūlymas
                                                </option>

                                                <option value="kita">
                                                    Kita
                                                </option>
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-bold text-gray-700 mb-2">
                                                Jūsų žinutė
                                            </label>

                                            <textarea
                                                required
                                                rows="5"
                                                value={formData.message}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        message: e.target.value
                                                    })
                                                }
                                                className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-100 rounded-xl focus:border-purple-500 outline-none transition resize-none"
                                                placeholder="Kaip galime jums padėti?"
                                            />
                                        </div>

                                        <button
                                            type="submit"
                                            disabled={
                                                status === 'sending'
                                            }
                                            className="w-full py-4 bg-gradient-to-r from-purple-600 to-pink-500 text-white rounded-xl font-bold text-lg hover:shadow-xl transition transform hover:scale-[1.02] disabled:opacity-50"
                                        >
                                            {status === 'sending'
                                                ? 'Siunčiama...'
                                                : 'Siųsti žinutę 🚀'}
                                        </button>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Contacts;
